module.exports = __webpack_public_path__ + "static/img/3.a7778c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/zlgl/3.jpg
// module id = r+cV
// module chunks = 0